export default function getData(location) {
  if (location === void 0) {
    location = {};
  }
  return {
    address: {
      '@context': 'https://schema.org',
      '@type': 'PostalAddress',
      addressLocality: location.address.city,
      addressRegion: location.address.state,
      postalCode: location.address.zip,
      streetAddress: location.address.address1
    }
  };
}